import Vue from "vue";
import "moment/locale/es";
import Datetime from "vue-datetime";
import VeeValidate from "vee-validate";
import es from "vee-validate/dist/locale/es";
import VueToastr from "@deveodk/vue-toastr";
import VueTheMask from "vue-the-mask";
import Pagination from "vue-pagination-2";
import App from "./App.vue";
import router from "./router";
import Auth from "./config/auth.js";
import axios from "./config/axios.js";
import vuexStore from "./store";
import AppModal from "./components/acciones/BaseModal.vue";
import "./config/filtros.js";
import "./components/comunes";
import "./registerServiceWorker";

const pkg = require("../package.json").name;

Vue.config.productionTip = false;

Vue.use(VueToastr);
Vue.use(Auth, axios, { pkg });
Vue.use(Datetime);
Vue.use(VueTheMask);

Vue.component("app-modal", AppModal);
Vue.component("pagination", Pagination);

Vue.prototype.$auth.checkAuth();

Vue.use(VeeValidate, {
  dictionary: { es },
});

/* eslint-disable no-new */
export default new Vue({
  el: "#app",
  router,
  store: vuexStore,
  components: { App },
  render: h => h(App),
});
